import type { Must } from '@shared/shop-api/core/types'

export const isClientData = <TData extends Record<string, unknown>>(
  data: TData | null
): data is Must<TData> => {
  if (!data) {
    return false
  }

  const isObject = typeof data === 'object' && data !== null

  if (isObject && data) {
    return Object.keys(data).every((key) => {
      const value = data?.[key]

      return value !== undefined && value !== null
    })
  }

  return false
}

export const getLastPart = (id: string, delimiter: string) => {
  const part = id.split(delimiter).pop()

  if (!part) {
    throw new Error(`Invalid ID: ${id}`)
  }

  return part
}

export const gidToId = (gid: string): number => {
  const realId = getLastPart(gid, '/')

  const id = parseInt(realId)

  if (isNaN(id)) {
    throw new Error(`Invalid GID: ${gid}`)
  }

  return id
}

export const generateId = (prefix: string) =>
  `${prefix}${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`
